/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Switch variant callouts between one-time and subscription
  function initVariantCalloutSwitcher() {
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');

    function displayOTPCallouts() {
      const options = document.querySelectorAll('[data-variant-buttons] .radio__button');

      if (!options || options.length === 0) {
        return;
      }

      options.forEach((option) => {
        option.querySelector('[js-skio-variant-selector-callout]')?.classList.remove('hidden');
      });
    }
    function updateCallouts() {
      const isSubscription = sellingPlanInput?.value && sellingPlanInput?.value !== '';
      const callouts = document.querySelectorAll('[js-skio-variant-selector-callout]');
      
      callouts.forEach((callout) => {
        const newText = isSubscription ? 
          callout.dataset.subscriptionCallout : 
          callout.dataset.oneTimeCallout;
          
        if (newText) {
          callout.textContent = newText;
        }
      });
    }
    
    if (!sellingPlanInput) {
      updateCallouts();
      displayOTPCallouts();
      return;
    };
    
    // Watch for changes to the hidden input
    const observer = new MutationObserver(updateCallouts);
    observer.observe(sellingPlanInput, { 
      attributes: true, 
      attributeFilter: ['value'] 
    });
    
    sellingPlanInput.addEventListener('change', updateCallouts);
    document.addEventListener('skio:selling-plan-changed', updateCallouts);
    
    updateCallouts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantCalloutSwitcher);
  } else {
    initVariantCalloutSwitcher();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();